import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import Verify from './modules/verify_page/verify';
import MainPage from './Components/MainPage';
import HomePage from './Components/HomePage';
import AboutTeam from './Components/AboutTeam';
import HowItWorks from './Components/HowItWorks';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
      <Routes>
        <Route path = "/" element = {<HomePage />} />
        <Route path = "/verify/" element = {<Verify />}/>
        <Route path = "/mainpage/" element = {<MainPage/>} />
        <Route path = "/aboutteam/" element = {<AboutTeam />} />
        <Route path = "/howitworks/" element = {<HowItWorks />} />
      </Routes>
  </BrowserRouter>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
